/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import { useLanguage } from "../context/LanguageContext";
import "../styles/Magazine.css";

const translations = {
  ES: {
    title: "La revista",
  },
  CAT: {
    title: "La revista",
  },
};

const Magazine = () => {
  const { language } = useLanguage();
  const { title } = translations[language];

  return (
    <section className="magazine">
      <h2>{title}</h2>
      <iframe
        allowFullScreen="allowFullScreen"
        className="fp-iframe"
        src="https://heyzine.com/flip-book/b7850566fa.html"
        style={{
          border: "1px solid lightgray",
          width: "100%",
          height: "600px",
        }}
      ></iframe>
    </section>
  );
};

export default Magazine;
